
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {API} from '../../assets/js/api';
import Clipboard from "clipboard";

export default {
name: 'Index',
components: {
XDialog, Alert, Toast
},

props: ['hideRecharge', 'hideLog', 'changeInfo', 'showLoginBox'],
data () {
return {
isShowLoginToast: false,
isShowregDialog: false,
pageType: 1,
showService: false,
showHintMsg: false,
toastMsg: {
text: '',
type: '',
},
login: {
mobile: '',
pass: '',
},
loginSms: {
mobile: '',
captcha: '',
},
reg: {
mobile: '',
password: '',
captcha: '',
comfirmPass: '',
},
userInfo: {},
serverImg: 'https://static.diantoushi.com/cnd/qrcode/dts-qr_003.png',
isLoginSmscode: true,
isCangetCode: false,
smstext: '获取验证码',
}
},
methods: {
getSmscode: function () {
if (!this.isCangetCode) return;
if (!this.loginSms.mobile) {
this.$vux.toast.show({
text: '请先填写手机号',
type: 'text',
width: 'auto',
})
return;
}
if (!/^1[3456789]\d{9}$/.test(this.loginSms.mobile)) {
this.$vux.toast.show({
text: '请填写正确的手机号',
type: 'text',
width: 'auto',
})
return;
}
this.$ajax.get(API.getcaptcha, {params: {mobile: this.loginSms.mobile}}).then(res => {
if (res.status < 0) {
this.$vux.toast.show({
text: res.message,
type: 'text',
width: 'auto',
})
return;
} else {
this.$vux.toast.show({
text: '验证码发送成功',
type: 'text',
width: 'auto',
})
this.isCangetCode = false;
this.getVefiry();
}
})
},
getVefiry: function () {
var countdown = 60, self = this;
clearInterval(window._verify_timer);
window._verify_timer = null;
window._verify_timer = setInterval(function () {
countdown--;
var tips = countdown + "s后重新获取";
self.isCangetCode = false;
if (countdown === 0) {
clearInterval(window._verify_timer);
tips = '获取验证码';
self.isCangetCode = true;
}
self.smstext = tips;
}, 1000);
},
goCharge: function () {
this.$router.push('/goldbuy');
},
goPage: function (type) {
if (type != 4) {
this.pageType = type;
}
let url = '';
switch (type) {
case 1: url = '/index';
break;
case 2: url = '/blackcheck';
break;
case 3: url = '/goldbuy';
break;
case 4: this.showService = true;
break;
case 5: url = '/oprationdata';
break
default:
break;
}
this.$emit('changePage', url);
},
goLogin: function () {
let d = this.login, reqUrl, params, sd = this.loginSms;
if (this.isLoginSmscode) {
if (!sd.mobile || !sd.captcha) {
this.showHintMsg = true;
this.toastMsg = {text: sd.mobile ? '请输入验证码' : '请输入手机号'}
return;
}
reqUrl = API.captchaLogin;
params =  {"mobile": sd.mobile, "captcha": sd.captcha};
} else {
if (!d.mobile || !d.pass) {
this.showHintMsg = true;
this.toastMsg = {text: d.mobile ? '请输入密码' : '请输入手机号'}
return;
}
reqUrl = API.login;
params =  {"mobile": d.mobile, "password": d.pass};
}
this.$ajax.post(reqUrl, params).then(res => {
if (res.status < 0) {
this.$vux.toast.show({
text: res.message,
type: 'text',
width: 'auto',
})
return;
}
if (res.extData) {
this.userInfo = res.extData;
this.isShowLoginToast = false;
this.$vux.toast.show({
text: "登录成功~",
type: 'text',
width: 'auto',
})
this.$emit('listenLoginStatus', 'y');
window.localStorage.setItem('DTS_USER_TOKEN', res.extData.token);
}
}).catch(() => {
this.$vux.toast.show({
text: '系统错误，稍后重试',
type: 'text',
width: 'auto',
})
})
},
subReg: function () {
let d = this.reg;
if (!d.mobile || !d.password || !d.captcha) {

this.showHintMsg = true;
this.toastMsg = {text: d.mobile ? '请输入密码' : '请输入手机号'}
return;
}
let reqData = {"mobile": d.mobile, "password": d.password};
this.$ajax.post(API.login, reqData).then(res => {
if (res.status < 0) {
this.$vux.toast.show({
text: res.message,
type: 'text',
width: 'auto',
})
return;
}
if (res.extData) {
this.dioramaData = res.extData;
}
}).catch(() => {
this.$vux.toast.show({
text: '系统错误，稍后重试',
type: 'text',
width: 'auto',
})
})
},
getUserInfo: function () {
this.$ajax.get(API.userInfo, {params: {key:233}}).then(res => {
if (res.status < 0) {
this.$vux.toast.show({
text: res.message,
type: 'text',
width: 'auto',
})
return;
}
let d = res.extData;
if (d) {
this.userInfo = {
mobile: d.mobile,
goldDayBalance: d.goldDayBalance,
goldBalance: d.goldBalance,
}
}
})
},
changeOperate: function (type) {
if (type === 'login') {
this.isShowregDialog = false;
this.isShowLoginToast = true;
} else if (type === 'reg') {
this.isShowregDialog = true;
this.isShowLoginToast = false;
}
},
loginout: function () {
this.$ajax.get(API.loginout, {params: {key:233}}).then(res => {
if (res.status < 0) {
this.$vux.toast.show({
text: res.message,
type: 'text',
width: 'auto',
})
return;
}else {
this.$vux.toast.show({
text: '退出登录成功',
type: 'text',
width: 'auto',
});
window.location.reload();
}
})
},
closeDialog: function () {
this.showService = false;
},
initCopy: function () {
let self = this;
this.$nextTick(() => {
const copybtn = this.$refs.copy;
let clipboard = new Clipboard(copybtn);
clipboard.on("success", function () {
self.$vux.toast.show({
text: "复制成功，请添加微信好友",
type: 'text',
width: '250px',
})
});

clipboard.on("error", function () {
self.$vux.toast.show({
text: "复制失败",
type: 'text',
width: 'auto',
})
});
});
},
},
mounted() {
this.initCopy()
let url = window.location.href, self = this;
url = url.slice(url.indexOf('#/')+2);
if (/index/gi.test(url) || !url) {
this.pageType = 1;
}else if (/blackcheck/gi.test(url)) {
this.pageType = 2;
}else if (/goldbuy/gi.test(url)) {
this.pageType = 3;
} else if (/oprationdata/gi.test(url)){
this.pageType = 5;
}
this.getUserInfo();










this.isCangetCode = /^1[3456789]\d{9}$/.test(self.loginSms.mobile);

document.querySelector('.smsmobileinput').addEventListener('input', function() {
self.isCangetCode = /^1[3456789]\d{9}$/.test(self.loginSms.mobile);
})
},
watch: {
'changeInfo': function () {
if (this.changeInfo == 'y') {
this.getUserInfo();
}
},
'showLoginBox': function () {
this.isShowLoginToast = true;
}
},
}
